import React, { Component } from "react";

import PropTypes from "prop-types";

const PoolDataContext = React.createContext(() => {});

export class PoolDataProvider extends Component {
  static displayName = "PoolDataProvider";
  static propTypes = {
    fetchPoolData: PropTypes.func.isRequired,
  };

  _isMounted = null;

  idPoolTracker = new Set();

  componentDidMount() {
    this._isMounted = true;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  safeSetState(...args) {
    if (this._isMounted) {
      this.setState(...args);
    }
  }

  fetchPoolData = poolId => {
    this.idPoolTracker.add(poolId);
    this.props
      .fetchPoolData(poolId)
      .then(pool => {
        this.safeSetState(prevState => ({
          poolData: { ...prevState.poolData, [poolId]: pool },
        }));
        this.idPoolTracker.delete(poolId);
      })
      .catch(() => {}); // leave in tracker so we don't refetch
  }

  getItem = key => poolId => {
    const item = this.state[key][poolId];
    return item;
  };

  fetchPoolDataIfNotCached = poolId => {
    const item = this.getItem("poolData")(poolId);
    if (!item && !this.idPoolTracker.has(poolId)) {
      this.fetchPoolData(poolId);
    }
  }

  state = {
    poolData: {},
    fetchPoolDataIfNotCached: this.fetchPoolDataIfNotCached,
    fetchPoolData: this.fetchPoolData,
  };

  render() {
    // eslint-disable-next-line
    return <PoolDataContext.Provider value={this.state}>{this.props.children}</PoolDataContext.Provider>;
  }
}

export default PoolDataContext;
